import React, { Dispatch, SetStateAction } from 'react';
import { ModalContainer, Spinner } from '@welbe/web-design-system';
import { AiOutlineClose as Close } from 'react-icons/ai';
import RejectCandidate from 'App/assets/img/reject_candidate.svg?url';

import { ModalConfirm } from 'App/Components/ModalConfirm/ModalConfirm';

import {
	Container,
	CloseBackground,
	ContentTitle,
	Content,
	ContentButton,
	Icon,
	ContainerSpinner,
} from './ModalRejectCandidate.styles';

import { useModalRejectCandidate } from './ModalRejectCandidate.hooks';

import { Candidate } from 'types';
import { Button } from '@welbe/design-system';

type ModalConfirmProps = {
	selectedCandidates: Candidate[];
	setSelectedCandidates: Dispatch<SetStateAction<Candidate[]>>;
	setReloadTable: Dispatch<SetStateAction<boolean>>;
	handleClose: () => void;
};

export const ModalRejectCandidate = ({
	selectedCandidates,
	setSelectedCandidates,
	setReloadTable,
	handleClose,
}: ModalConfirmProps): JSX.Element => {
	const { handleRejectCandidates, confirmModal, isLoadingRejectCandidate } =
		useModalRejectCandidate({
			selectedCandidates,
			setSelectedCandidates,
			setReloadTable,
			handleClose,
		});

	return (
		<>
			<ModalContainer
				visible
				height="290px"
				zIndex={1100}
				headerIcon={<Icon src={RejectCandidate} />}
				closeOnlyOnTheButton
			>
				<Container>
					<CloseBackground onClick={handleClose}>
						<Close fontSize="medium" />
					</CloseBackground>

					<ContentTitle>Declinar candidatos</ContentTitle>
					{isLoadingRejectCandidate ? (
						<ContainerSpinner>
							<Spinner size="4vh" />
						</ContainerSpinner>
					) : (
						<>
							<Content>
								{selectedCandidates && selectedCandidates.length > 1
									? `¿Estás seguro que deseas declinar estos ${selectedCandidates.length} candidatos?`
									: `¿Estás seguro que deseas declinar candidato ${selectedCandidates[0].name}?`}
							</Content>
							<ContentButton>
								<Button
									key={'1'}
									type="button"
									onClick={handleClose}
									width={'150px'}
									variant="outline"
								>
									Regresar
								</Button>
								<Button
									key={'2'}
									type="button"
									onClick={handleRejectCandidates}
									width={'150px'}
								>
									Confirmar
								</Button>
							</ContentButton>
						</>
					)}
				</Container>
			</ModalContainer>
			<ModalConfirm
				visible={confirmModal.show}
				onClose={confirmModal.onClose}
				imageUrl={confirmModal.icon}
				message={confirmModal.message}
			/>
		</>
	);
};
